/* eslint-disable */
export default {
  pages: {
    key: "title",
    data: [
     /*{ title: "Bank Account",     url: "/bankaccounts",    icon: "DollarSignIcon",           is_bookmarked: false},
      
            { title: "Dashboard",     url: "/dashboard/analytics",    icon: "HomeIcon",           is_bookmarked: true},
            { title: "Finance",     url: "/dashboard/finance",    icon: "ActivityIcon",           is_bookmarked: true},
            { title: "Calendar",     url: "/calendar",    icon: "CalendarIcon",           is_bookmarked: true},
            { title: "People",     url: "/people/people-list",    icon: "UsersIcon",           is_bookmarked: true},          
            { title: "Add New Person",     url: "/person-add",    icon: "UsersIcon",           is_bookmarked: false},         
            { title: "Add New People",     url: "/person-add",    icon: "UsersIcon",           is_bookmarked: false},
            { title: "Users",     url: "/configurations/users-list",    icon: "UserIcon",           is_bookmarked: false},

            
            { title: "Quotation",     url: "/quotation/quotation-list",    icon: "DollarSignIcon",           is_bookmarked: false},
            { title: "New Quotation",     url: "/quotation-add",    icon: "DollarSignIcon",           is_bookmarked: false},
            { title: "Invoice",     url: "/invoice/invoice-list",    icon: "UploadIcon",           is_bookmarked: true},

            { title: "Purchase Order",     url: "/purchase/purchase-list",    icon: "ShoppingCartIcon",           is_bookmarked: false},
            { title: "New Purchase Order",     url: "/purchase-add",    icon: "ShoppingCartIcon",           is_bookmarked: false},

            { title: "Reception",     url: "/reception/reception-list",    icon: "DownloadIcon",           is_bookmarked: false},
            { title: "New Reception",     url: "/reception-add",    icon: "DownloadIcon",           is_bookmarked: false},
            { title: "Production",     url: "/production/production-list",    icon: "ZapIcon",           is_bookmarked: true},
            
            { title: "Transport",     url: "/transport/transport-list",    icon: "TruckIcon",           is_bookmarked: true},
            /*{ title: "New Outlay",     url: "/outlay-add",    icon: "ShoppingBagIcon",           is_bookmarked: false},
            { title: "New Outlay Simplified",     url: "/outlay-add-simple",    icon: "ShoppingBagIcon",           is_bookmarked: false},
            { title: "Outlay",     url: "/outlay/outlay-list",    icon: "ShoppingBagIcon",           is_bookmarked: true},
            { title: "New Transport",     url: "/transport-add",    icon: "TruckIcon",           is_bookmarked: false},
            { title: "Inventory",     url: "/inventory/inventory-list",    icon: "ListIcon",           is_bookmarked: false},
            { title: "New Transformation",     url: "/transformation-add",    icon: "ZapIcon",           is_bookmarked: false},
            { title: "New Inventory",     url: "/inventory-add",    icon: "ListIcon",           is_bookmarked: false},
            { title: "Stock",     url: "/stock/stock-list",    icon: "PackageIcon",           is_bookmarked: true},
            { title: "Product",     url: "/product/product-list",    icon: "PackageIcon",           is_bookmarked: false},
            { title: "Product Category",     url: "/product/product-category-list",    icon: "PackageIcon",           is_bookmarked: false},*/
    ]
  }/*,
  files: {
    key:"file_name",
    data: [
      { file_name: "Joe's CV",         from:"Stacy Watson",    file_ext:"doc", size:"1.7 mb"  },
    ]
  },
  contacts: {
    key:"name",
    data: [
      { img: require("@/assets/images/portrait/small/avatar-s-4.jpg"),  name: "Chady",          email: "nephrod@preany.co.uk",     time: "21/05/2019" },
    ]
  },*/
}
